/* Tyffco V3 — motion runtime (DESIGN.md §7). Vanilla, sem libs. */
(function () {
  'use strict';

  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Reveals: um IO só, dispara 1x, nunca re-anima.

     SAFETY-NET (2026-07-30). Antes desta versão, se o IntersectionObserver não
     disparasse o conteúdo ficava invisível para sempre — sem erro no console,
     sem nada quebrado à vista. Já aconteceu antes (lição 2026-06-26, severidade
     alta), e com o stagger do grid a aposta sobe: o que some deixa de ser uma
     frase e passa a ser a loja.

     Duas redes, porque são duas falhas diferentes:

     1. THRESHOLD que nunca é atingido. `threshold: 0.2` pede 20% da área DO
        ELEMENTO visível. Uma seção full-bleed mais alta que ~5× a janela nunca
        chega lá — em mobile isso alcança o line-split e os heroes. Falha
        silenciosa e determinística, não aleatória. Corrigido observando também
        em 0 e aceitando qualquer intersecção quando o elemento é mais alto que
        70% da janela.
     2. IO que não dispara. Watchdog revela o que já deveria estar visível e,
        se concluir que o IO está morto, liga um fallback por scroll. */
  var SAFETY_MS = 2000;

  function noViewport(n) {
    var r = n.getBoundingClientRect();
    if (!r.height && !r.width) return true; // altura 0 nunca intersecta
    return r.top < (window.innerHeight || 0) && r.bottom > 0;
  }

  function acimaOuNoViewport(n) {
    var r = n.getBoundingClientRect();
    return r.top < (window.innerHeight || 0);
  }

  function initReveals() {
    var nodes = document.querySelectorAll('.tyf-reveal, .tyf-rule--draw');
    if (!nodes.length) return;

    function revela(n) { n.classList.add('is-in'); }

    if (reducedQuery.matches || !('IntersectionObserver' in window)) {
      nodes.forEach(revela);
      return;
    }

    var disparou = false;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var alto = entry.boundingClientRect.height > (window.innerHeight || 0) * 0.7;
          if (entry.intersectionRatio < 0.2 && !alto) return;
          disparou = true;
          revela(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: [0, 0.2], rootMargin: '0px 0px -10% 0px' }
    );
    nodes.forEach(function (n) { io.observe(n); });

    /* Watchdog. Só revela o que já deveria estar visível — o que está abaixo
       continua esperando o scroll, senão o efeito morre junto com o bug. */
    window.setTimeout(function () {
      var pendentes = [];
      nodes.forEach(function (n) {
        if (n.classList.contains('is-in')) return;
        if (acimaOuNoViewport(n)) { revela(n); io.unobserve(n); }
        else pendentes.push(n);
      });

      /* Se nada disparou e havia candidato no viewport, o IO não é confiável
         nesta sessão: assume o controle por scroll. */
      if (disparou || !pendentes.length) return;
      var agendado = false;
      function varre() {
        agendado = false;
        for (var i = pendentes.length - 1; i >= 0; i--) {
          if (noViewport(pendentes[i])) { revela(pendentes[i]); pendentes.splice(i, 1); }
        }
        if (!pendentes.length) window.removeEventListener('scroll', agenda);
      }
      function agenda() {
        if (agendado) return;
        agendado = true;
        window.requestAnimationFrame(varre);
      }
      window.addEventListener('scroll', agenda, { passive: true });
      window.addEventListener('resize', agenda, { passive: true });
      varre();
    }, SAFETY_MS);
  }

  /* Above the fold: primeira seção revela no load, sem IO. */
  function revealAboveFold() {
    var first = document.querySelector('main .shopify-section:first-child');
    if (!first) return;
    first.querySelectorAll('.tyf-reveal, .tyf-rule--draw').forEach(function (n) {
      n.classList.add('is-in');
    });
  }

  /* Vídeos decorativos: play/pause por visibilidade + botão manual. */
  function initVideos() {
    var videos = document.querySelectorAll('video[data-tyf-loop]');
    if (!videos.length) return;

    videos.forEach(function (video) {
      var toggle = video.parentElement.querySelector('.tyf-video-toggle');
      var userPaused = false;

      function play() {
        if (userPaused || reducedQuery.matches) return;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        if (toggle) toggle.setAttribute('data-state', 'playing');
      }
      function pause() {
        video.pause();
        if (toggle) toggle.setAttribute('data-state', 'paused');
      }

      if (toggle) {
        toggle.setAttribute('data-state', reducedQuery.matches ? 'paused' : 'playing');
        toggle.addEventListener('click', function () {
          if (video.paused) {
            userPaused = false;
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
            toggle.setAttribute('data-state', 'playing');
          } else {
            userPaused = true;
            pause();
          }
        });
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.intersectionRatio >= 0.4) play();
              else pause();
            });
          },
          { threshold: [0, 0.4] }
        );
        io.observe(video);
      } else if (!reducedQuery.matches) {
        play();
      }

      reducedQuery.addEventListener('change', function (e) {
        if (e.matches) pause();
      });
    });
  }

  /* Aba em background continua decodificando vídeo, queimando CPU e bateria
     (achado 2026-07-30). O IO cuida de visibilidade no viewport, não de
     visibilidade do documento. */
  function initPageVisibility() {
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) return;
      document.querySelectorAll('video[data-tyf-loop]').forEach(function (v) {
        if (!v.paused) v.pause();
      });
    });
  }

  /* Stagger do grid de coleção.

     Achado em 31/07: o grid de produtos das páginas de linha tinha ZERO reveals,
     enquanto hero, manifesto e crossover animavam. O maior bloco da página, e
     justamente o conteúdo principal, ficava fora do sistema — era isso que fazia
     as duas páginas parecerem desencaixadas.

     Feito por JS e não no Liquid de propósito: `main-collection-product-grid`
     é seção core do Dawn, e tudo que fizemos até aqui é aditivo. Um seletor aqui
     sobrevive a upgrade do tema; um patch lá, não.

     O stagger só entra DEPOIS do safety-net (Sprint 0) porque, sem ele, um IO
     que não dispara deixaria de esconder uma frase e passaria a esconder o
     catálogo inteiro. */
  function initGridStagger() {
    var itens = document.querySelectorAll(
      '.collection .grid__item, .collection-list .grid__item'
    );
    if (!itens.length) return;
    if (reducedQuery.matches) return;

    /* A coluna sai do `offsetLeft`: dentro de uma linha ele cresce, e quando
       volta a cair começou linha nova. Funciona com grid E com flex, e não
       depende das imagens terem assentado.

       Duas tentativas anteriores falharam, e vale registrar: comparar
       `getBoundingClientRect().top` rodava antes do layout e contou 2 colunas
       em Performance contra 3 em Everyday, sendo os grids idênticos; ler
       `grid-template-columns` devolveu `none`, porque o `.grid` do Dawn é flex,
       e todo delay virou 0.

       O delay reinicia a cada linha de propósito. Escalonar 1..N pela página
       faria a última peça de uma grade de 8 esperar meio segundo depois de já
       estar visível, e isso se lê como travamento, não como ritmo. */
    var coluna = 0;
    var anterior = -1;
    itens.forEach(function (n) {
      var esq = n.offsetLeft;
      if (esq <= anterior) coluna = 0;
      anterior = esq;
      n.classList.add('tyf-reveal');
      n.setAttribute('data-reveal', 'slide');
      n.style.setProperty('--tyf-delay', coluna * 70 + 'ms');
      coluna += 1;
    });
  }

  /* Reforço do bloqueio de compra sem preço.

     O CSS já esconde a zona de compra via `:has()`, que cobre a esmagadora
     maioria dos navegadores. Este reforço existe porque a consequência de falhar
     não é estética: seria alguém finalizando a compra de um produto por 0,00.
     Quando o risco é esse, uma camada só não basta. */
  function initGuardaDePreco() {
    var aviso = document.querySelector('.tyf-pdp-pending');
    if (!aviso) return;
    var info = aviso.closest('.product__info-container') || document;
    ['.product-form', '.shopify-payment-button', '.product-form__buttons', '.price']
      .forEach(function (sel) {
        info.querySelectorAll(sel).forEach(function (n) { n.style.display = 'none'; });
      });
  }

  function init() {
    revealAboveFold();
    initGuardaDePreco();
    initGridStagger();
    initReveals();
    initVideos();
    initPageVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
